import React from 'react';

interface IconBlueChannelProps {
    width?: number | string;
    height?: number | string;
}

const IconBlueChannel: React.FC<IconBlueChannelProps> = ({ width = 17, height = 17 }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 17 17"
        fill="none"
    >
        <path
            d="M8.00027 0C3.60656 0 0 3.60711 0 7.99918C0 12.3945 3.60656 16 8.00027 16C12.3956 16 16 12.3945 16 7.99918C15.9995 3.60711 12.3956 0 8.00027 0Z"
            fill="blue"
        />
    </svg>
);

export default IconBlueChannel;
